import { render, staticRenderFns } from "./voice-player.vue?vue&type=template&id=0c23c9ec&scoped=true"
import script from "./voice-player.vue?vue&type=script&lang=js"
export * from "./voice-player.vue?vue&type=script&lang=js"
import style0 from "./voice-player.vue?vue&type=style&index=0&id=0c23c9ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23c9ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c23c9ec')) {
      api.createRecord('0c23c9ec', component.options)
    } else {
      api.reload('0c23c9ec', component.options)
    }
    module.hot.accept("./voice-player.vue?vue&type=template&id=0c23c9ec&scoped=true", function () {
      api.rerender('0c23c9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/voice-player.vue"
export default component.exports